import { getOptions, 
         getDevices, 
         getExternalDevices, 
         getRegions, 
         getCardTypes, 
         getStopTypes, 
         getRouteDayparts, 
         getRouteOptions, 
         getRouteTypes, 
         getBuses, 
         getDrivers, 
         getAids, 
         getNotifierTypes, 
         getRoutes, 
         getMessageReceivers, 
         getMessageTypes,
         getDefectTypes,
         getStudents } from '@/apis/common'
import { formatNameWithAlias, formatName } from '@/utils'

const state = {
    fetchDevice: false,
    fetchExternalDevice: false,
    devices: [],
    externalDevices: [],
    regions: [],
    cardTypes: [],
    stopTypes: [],
    routeDayparts: [],
    routeOptions: [],
    routeTypes: [],
    buses: [],
    drivers: [],
    fetchAid: false,
    aids: [],
    notifierTypes: [],
    fetchAllOptions: false,
    fetchRoute: false,
    routes: [],
    messageReceivers: [],
    messageTypes: [],
    defectTypes: [],
    students: [],
}

const mutations = {
    SET_FETCH_ALL: (state, fetchAllOptions) => {
        state.fetchAllOptions = fetchAllOptions
    },
    SET_FETCH_DEVICE: (state, fetchDevice) => {
        state.fetchDevice = fetchDevice
    },
    SET_FETCH_EXTERNAL_DEVICE: (state, fetchExternalDevice) => {
        state.fetchExternalDevice = fetchExternalDevice
    },
    SET_FETCH_AID: (state, fetchAid) => {
        state.fetchAid = fetchAid
    },
    SET_FETCH_ROUTE: (state, fetchRoute) => {
        state.fetchRoute = fetchRoute
    },
    SET_DEVICES: (state, devices) => {
        state.devices = devices
    },
    SET_EXTERNAL_DEVICES: (state, externalDevices) => {
        state.externalDevices = externalDevices
    },
    SET_REGIONS: (state, regions) => {
        state.regions = regions
    },
    SET_CARD_TYPES: (state, cardTypes) => {
        state.cardTypes = cardTypes
    },
    SET_STOP_TYPES: (state, stopTypes) => {
        state.stopTypes = stopTypes
    },
    SET_ROUTE_DAYPARTS: (state, routeDayparts) => {
        state.routeDayparts = routeDayparts
    },
    SET_ROUTE_OPTIONS: (state, routeOptions) => {
        state.routeOptions = routeOptions
    },
    SET_ROUTE_TYPES: (state, routeTypes) => {
        state.routeTypes = routeTypes
    },
    SET_BUSES: (state, buses) => {
        state.buses = buses.map(el => {
            el.name = formatNameWithAlias(el.name, el.plate_number)
            return el
        })
    },
    SET_DRIVERS: (state, drivers) => {
        state.drivers = drivers.map(el => {
            el.name = formatName(el.first_name, el.last_name)
            return el
        })
    },
    SET_AIDS: (state, aids) => {
        state.aids = aids
    },
    SET_NOTIFIER_TYPES: (state, notifierTypes) => {
        state.notifierTypes = notifierTypes
    },
    SET_ROUTES: (state, routes) => {
        state.routes = routes.map(el => {
            el.full_name = formatNameWithAlias(el.name, el.alias)
            return el
        })
    },
    SET_MESSAGE_RECEIVERS: (state, messageReceivers) => {
        state.messageReceivers = messageReceivers
    },
    SET_MESSAGE_TYPES: (state, messageTypes) => {
        state.messageTypes = messageTypes
    },
    SET_DEFECT_TYPES: (state, defectTypes) => {
        state.defectTypes = defectTypes
    },
    SET_STUDENTS: (state, students) => {
        state.students = students.map(el => {
            el.name = formatName(el.first_name, el.last_name)
            return el
        })
    },
}

const actions = {
    getOptions({ commit, state }, isForce=false) {
        return new Promise((resolve, reject) => {
            if(state.fetchAllOptions && !isForce) {
                resolve()
            }else {
                getOptions().then(response => {
                    const { data } = response
                    if(data.regions !== undefined) {
                        commit('SET_REGIONS', data.regions || [])
                    }
                    if(data.card_types !== undefined) {
                        commit('SET_CARD_TYPES', data.card_types || [])
                    }
                    if(data.stop_types !== undefined) {
                        commit('SET_STOP_TYPES', data.stop_types || [])
                    }
                    if(data.route_dayparts !== undefined) {
                        commit('SET_ROUTE_DAYPARTS', data.route_dayparts || [])
                    }
                    if(data.route_options !== undefined) {
                        commit('SET_ROUTE_OPTIONS', data.route_options || [])
                    }
                    if(data.route_types !== undefined) {
                        commit('SET_ROUTE_TYPES', data.route_types || [])
                    }
                    if(data.buses !== undefined) {
                        commit('SET_BUSES', data.buses || [])
                    }
                    if(data.drivers !== undefined) {
                        commit('SET_DRIVERS', data.drivers || [])
                    }
                    if(data.aids !== undefined) {
                        commit('SET_AIDS', data.aids || [])
                    }
                    if(data.notifier_types !== undefined) {
                        commit('SET_NOTIFIER_TYPES', data.notifier_types || [])
                    }
                    if(data.routes !== undefined) {
                        commit('SET_ROUTES', data.routes || [])
                    }
                    if(data.message_receivers !== undefined) {
                        commit('SET_MESSAGE_RECEIVERS', data.message_receivers || [])
                    }
                    if(data.message_types !== undefined) {
                        commit('SET_MESSAGE_TYPES', data.message_types || [])
                    }
                    if(data.inspection_defect_types !== undefined) {
                        commit('SET_DEFECT_TYPES', data.inspection_defect_types || [])
                    }
                    if(data.students !== undefined) {
                        commit('SET_STUDENTS', data.students || [])
                    }
                    commit('SET_FETCH_ALL', true)
                    resolve(response)
                }).catch(error => { 
                    reject(error)
                })
            }
        })
    },
    getDevices({ commit, state }, isForce=false) {
        return new Promise((resolve, reject) => {
            if(state.fetchDevice && !isForce) {
                resolve()
            }else {
                getDevices().then(response => {
                    const { data } = response
                    commit('SET_DEVICES', data || [])
                    commit('SET_FETCH_DEVICE', true)
                    resolve(response)
                }).catch(error => { 
                    reject(error)
                })
            }
        })
    },
    getExternalDevices({ commit, state }, isForce=false) {
        return new Promise((resolve, reject) => {
            if(state.fetchExternalDevice && !isForce) {
                resolve()
            }else {
                getExternalDevices().then(response => {
                    const { data } = response
                    commit('SET_EXTERNAL_DEVICES', data || [])
                    commit('SET_FETCH_EXTERNAL_DEVICE', true)
                    resolve(response)
                }).catch(error => { 
                    reject(error)
                })
            }
        })
    },
    getRegions({ commit }) {
        return new Promise((resolve, reject) => {
            getRegions().then(response => {
                const { data } = response
                commit('SET_REGIONS', data || [])
                resolve(response)
            }).catch(error => { 
                reject(error)
            })
        })
    },
    getCardTypes({ commit }) {
        return new Promise((resolve, reject) => {
            getCardTypes().then(response => {
                const { data } = response
                commit('SET_CARD_TYPES', data || [])
                resolve(response)
            }).catch(error => { 
                reject(error)
            })
        })
    },
    getStopTypes({ commit }) {
        return new Promise((resolve, reject) => {
            getStopTypes().then(response => {
                const { data } = response
                commit('SET_STOP_TYPES', data || [])
                resolve(response)
            }).catch(error => { 
                reject(error)
            })
        })
    },
    getRouteDayparts({ commit }) {
        return new Promise((resolve, reject) => {
            getRouteDayparts().then(response => {
                const { data } = response
                commit('SET_ROUTE_DAYPARTS', data || [])
                resolve(response)
            }).catch(error => { 
                reject(error)
            })
        })
    },
    getRouteOptions({ commit }) {
        return new Promise((resolve, reject) => {
            getRouteOptions().then(response => {
                const { data } = response
                commit('SET_ROUTE_OPTIONS', data || [])
                resolve(response)
            }).catch(error => { 
                reject(error)
            })
        })
    },
    getRouteTypes({ commit }) {
        return new Promise((resolve, reject) => {
            getRouteTypes().then(response => {
                const { data } = response
                commit('SET_ROUTE_TYPES', data || [])
                resolve(response)
            }).catch(error => { 
                reject(error)
            })
        })
    },
    getBuses({ commit }) {
        return new Promise((resolve, reject) => {
            getBuses().then(response => {
                const { data } = response
                commit('SET_BUSES', data || [])
                resolve(response)
            }).catch(error => { 
                reject(error)
            })
        })
    },
    getDrivers({ commit }) {
        return new Promise((resolve, reject) => {
            getDrivers().then(response => {
                const { data } = response
                commit('SET_DRIVERS', data || [])
                resolve(response)
            }).catch(error => { 
                reject(error)
            })
        })
    },
    getAids({ commit, state }, isForce=false) {
        return new Promise((resolve, reject) => {
            if(state.fetchAid && !isForce) {
                resolve()
            }else {
                getAids().then(response => {
                    const { data } = response
                    commit('SET_AIDS', data || [])
                    commit('SET_FETCH_AID', true)
                    resolve(response)
                }).catch(error => { 
                    reject(error)
                })
            }
        })
    },
    getNotifierTypes({ commit }) {
        return new Promise((resolve, reject) => {
            getNotifierTypes().then(response => {
                const { data } = response
                commit('SET_NOTIFIER_TYPES', data || [])
                resolve(response)
            }).catch(error => { 
                reject(error)
            })
        })
    },
    getRoutes({ commit, state }, isForce=false) {
        return new Promise((resolve, reject) => {
            if(state.fetchRoute && !isForce) {
                resolve()
            }else {
                getRoutes().then(response => {
                    const { data } = response
                    commit('SET_ROUTES', data || [])
                    commit('SET_FETCH_ROUTE', true)
                    resolve(response)
                }).catch(error => { 
                    reject(error)
                })
            }
        })
    },
    getMessageReceivers({ commit }) {
        return new Promise((resolve, reject) => {
            getMessageReceivers().then(response => {
                const { data } = response
                commit('SET_MESSAGE_RECEIVERS', data || [])
                resolve(response)
            }).catch(error => { 
                reject(error)
            })
        })
    },
    getMessageTypes({ commit }) {
        return new Promise((resolve, reject) => {
            getMessageTypes().then(response => {
                const { data } = response
                commit('SET_MESSAGE_TYPES', data || [])
                resolve(response)
            }).catch(error => { 
                reject(error)
            })
        })
    },
    getDefectTypes({ commit }) {
        return new Promise((resolve, reject) => {
            getDefectTypes().then(response => {
                const { data } = response
                commit('SET_DEFECT_TYPES', data || [])
                resolve(response)
            }).catch(error => { 
                reject(error)
            })
        })
    },

    getStudents({ commit }) {
        return new Promise((resolve, reject) => {
            getStudents().then(response => {
                const { data } = response
                commit('SET_STUDENTS', data || [])
                resolve(response)
            }).catch(error => { 
                reject(error)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}